export async function onBackGroundButtonClicked(Scene, LeftorRight = '',ChButtons)
{
    let SelectionNumber = Scene.SelectedBackGround;
    let MoveLR;
    let FirePlaceDrop = 1000;
    if(LeftorRight)
    {
        (LeftorRight === "Left") ? SelectionNumber-- : SelectionNumber++;
        //MoveLR = (LeftorRight === "Left") ? -1024 : 1024;
        MoveLR = (LeftorRight === "Left") ? -898 : 898;

        //console.log(MoveLR);

        if(SelectionNumber === -1)
        {
            SelectionNumber = 3;
        }
        else if(SelectionNumber === 4)
        {
            SelectionNumber = 0;
        }

        //await _scrollOff();
        //Scene.BackGroundGroup.clear(true);
        Scene.SelectedBackGround = SelectionNumber;

        Scene.NewBack.setPosition(-(MoveLR),0);
    }
    Scene.AudioChan.Chan2.play("change_background");
    switch(SelectionNumber)
    {
        case 0:
            let BackDrp = Scene.NewBack.getData('BackGround')
            BackDrp.setFrame("BG_Stripes");
            Scene.NewBack.bringToTop(BackDrp);
            //Scene.CurrentBack.add(Scene.addImage(Scene.mid.x+63 + MoveLR, Scene.mid.y, "BG_Stripes"));
            break;
        case 1:
            _createModernBackground();
            _setBackDropDepth();
            break;
        case 2:
            _createRusticBackground();
            _setBackDropDepth();
            break;
        case 3:
            _createTraditionalBackground();
            _setBackDropDepth();
            break;
        default:
            break;
    }
    Scene.NewBack.getData('Emit').resume();
    for(let button in ChButtons)
    {
        ChButtons[button].disableInteractive();
    }
    await _scrollOff();
    for(let button in ChButtons)
    {
        ChButtons[button].setInteractive();
    }
    Scene.NewBack.getData('Emit').pause();

    Scene.BackGroundGroup.getChildren().forEach(element => {
        element.setDepth(Scene.DepthList.BackGround);
    });

    function _standardSetUp()
    {
        Scene.NewBack.getData('CurtainsRt').y -= FirePlaceDrop;
        Scene.NewBack.getData('CurtainsLt').y -= FirePlaceDrop;
        Scene.NewBack.getData('CurtainsRt').scaleY = .25;
        Scene.NewBack.getData('CurtainsLt').scaleY = .25;    
    }

    function _createModernBackground()
    {
        Scene.NewBack.getData('Sky').setFrame("Mod_Sky");
        Scene.NewBack.getData('BackGround').setFrame("Mod_BG");
        Scene.NewBack.getData('FirePlace').setFrame("Mod_Frplc");
        Scene.NewBack.getData('Wreath').setFrame("Mod_Wrth");
        Scene.NewBack.getData('Stocking').setFrame("Mod_Stckng");
        Scene.NewBack.getData('CurtainsRt').setFrame("Crtn_Teal");
        Scene.NewBack.getData('CurtainsLt').setFrame("Crtn_Teal");
        // Scene.NewBack.getData('TiesRt').setFrame("Mod_TiesRt");
        // Scene.NewBack.getData('TiesLt').setFrame("Mod_TiesRt");
        Scene.NewBack.getData('FirePlace').setPosition(309,410 - FirePlaceDrop);
        Scene.NewBack.getData('Stocking').setPosition(361,344-57);
        _standardSetUp()
        //Scene.NewBack.getData('BackGround').
        //Scene.BackGroundGroup.add(Scene.addImage(Scene.mid.x+63, Scene.mid.y, "Mod_BG"));
        //Scene.NewBack.add(Scene.addImage(Scene.mid.x+63 + MoveLR, Scene.mid.y, "Mod_BG"));
    }
    function _createRusticBackground()
    {
        Scene.NewBack.getData('Sky').setFrame("Rstc_Sky");
        Scene.NewBack.getData('BackGround').setFrame("Rstc_BG");
        Scene.NewBack.getData('FirePlace').setFrame("Rstc_Frplc");
        Scene.NewBack.getData('Wreath').setFrame("Rstc_Star");
        Scene.NewBack.getData('Stocking').setFrame("Rstc_Stkng");
        Scene.NewBack.getData('CurtainsRt').setFrame("Crtn_Grn");
        Scene.NewBack.getData('CurtainsLt').setFrame("Crtn_Grn");
        // Scene.NewBack.getData('TiesRt').setFrame("Rstc_TiesRt");
        // Scene.NewBack.getData('TiesLt').setFrame("Rstc_TiesRt");
        Scene.NewBack.getData('FirePlace').setPosition(307,379 - FirePlaceDrop);
        Scene.NewBack.getData('Stocking').setPosition(361,342-57);
        _standardSetUp()
        //Scene.BackGroundGroup.add(Scene.addImage(Scene.mid.x+63, Scene.mid.y, "Rstc_BG"));
        //Scene.NewBack.add(Scene.addImage(Scene.mid.x+63 + MoveLR, Scene.mid.y, "Rstc_BG"));
    }
    function _createTraditionalBackground()
    {
        Scene.NewBack.getData('Sky').setFrame("Trad_Sky");
        Scene.NewBack.getData('BackGround').setFrame("Trad_BG");
        Scene.NewBack.getData('FirePlace').setFrame("Trad_Frplc");
        Scene.NewBack.getData('Wreath').setFrame("Trad_Wrth");
        Scene.NewBack.getData('Stocking').setFrame("Trad_Stkng");
        Scene.NewBack.getData('CurtainsRt').setFrame("Crtn_Red");
        Scene.NewBack.getData('CurtainsLt').setFrame("Crtn_Red");
        // Scene.NewBack.getData('TiesRt').setFrame("Trad_TieRt");
        // Scene.NewBack.getData('TiesLt').setFrame("Trad_TieRt");
        Scene.NewBack.getData('FirePlace').setPosition(307,378 - FirePlaceDrop);
        Scene.NewBack.getData('Stocking').setPosition(361,342-57);
        _standardSetUp()
        //Scene.BackGroundGroup.add(Scene.addImage(Scene.mid.x+63, Scene.mid.y, "Trad_BG"));
        //Scene.NewBack.add(Scene.addImage(Scene.mid.x+63 + MoveLR, Scene.mid.y, "Trad_BG"));
    }
    function _setBackDropDepth()
    {
        let BackDrp = Scene.NewBack.getData('BackGround');
        //Scene.NewBack.sendToBack(BackDrp);
        //Scene.NewBack.moveUp(BackDrp);
        Scene.NewBack.moveTo(BackDrp,2);
        Scene.NewBack.getData('Fire1').setScale(0);
        Scene.NewBack.getData('Fire2').setScale(0);
        Scene.NewBack.getData('Fire3').setScale(0);
        Scene.NewBack.getData('Wreath').setScale(0);
        Scene.NewBack.getData('Stocking').setScale(0);
        Scene.NewBack.getData('FireWood').setAlpha(0);
        Scene.NewBack.getData('CurtainsRt').setAngle(0);
        Scene.NewBack.getData('CurtainsLt').setAngle(0);

    }
    function _swingTween(Obj,Decay,DecayRate)
    {
        let Time = 2;
        

        let Tween = Scene.addTween(Obj,Time*12,{angle:12,yoyo:true},Phaser.Math.Easing.Quadratic.InOut,()=>
        {
            let InitTween = Scene.addTween(Obj,Time*10,{angle:-10,yoyo:true},Phaser.Math.Easing.Quadratic.InOut,()=>
            {
                Scene.addTween(Obj,Time*8,{angle:8,yoyo:true},Phaser.Math.Easing.Quadratic.InOut,()=>
                {
                    Scene.addTween(Obj,Time*6,{angle:-6,yoyo:true},Phaser.Math.Easing.Quadratic.InOut,()=>
                    {
                        Scene.addTween(Obj,Time*4,{angle:4,yoyo:true},Phaser.Math.Easing.Quadratic.InOut,()=>
                        {
                            Scene.addTween(Obj,Time*2,{angle:-2,yoyo:true},Phaser.Math.Easing.Quadratic.InOut);
                        });
                    });
                
                });
                
            });
        });
        
    }

    function _fireBounce(Fire)
    {
        let FlameScale = Fire.scale;

        var Flamen = Scene.addTween(Fire, 100, {scaleY:FlameScale + .14, yoyo: true},Phaser.Math.Easing.Bounce.Quadratic,()=>{
            switch(Math.floor(Math.random()*3))
            {
                case 0:
                    Scene.addTween(Fire, 100, {scaleY:FlameScale + .1, yoyo: true,},Phaser.Math.Easing.Bounce.Quadratic,()=>{Flamen.play();});
                        break;
                case 1:
                    Scene.addTween(Fire, 60, {scaleY:FlameScale - .1, yoyo: true,},Phaser.Math.Easing.Bounce.Quadratic,()=>{Flamen.play();});
                    break;
                case 2:
                    Scene.addTween(Fire, 50, {scaleY:FlameScale + .05, yoyo: true,},Phaser.Math.Easing.Bounce.Quadratic,()=>{Flamen.play();});
                    break;
            }
        });

    }

    function _scrollOff()
    {
        return new Promise((resolve) => {
            let NewCurtains = [
                Scene.NewBack.getData('CurtainsRt'),
                Scene.NewBack.getData('CurtainsLt')
                // Scene.NewBack.getData('TiesRt'),
                // Scene.NewBack.getData('TiesLt')
            ];
            let OldCurtains = [
                Scene.CurrentBack.getData('CurtainsRt'),
                Scene.CurrentBack.getData('CurtainsLt')
                // Scene.CurrentBack.getData('TiesRt'),
                // Scene.CurrentBack.getData('TiesLt')
            ];
            // let NewCurtainTies = [
            //     Scene.NewBack.getData('TiesRt'),
            //     Scene.NewBack.getData('TiesLt')
            // ]
            // let OldCurtainTies = [
            //     Scene.CurrentBack.getData('TiesRt'),
            //     Scene.CurrentBack.getData('TiesLt')
            // ];
            // Scene.addTween(NewCurtainTies,25,{scale:0});
            // Scene.addTween(OldCurtainTies,25,{scale:0});

            let Tween = Scene.addTween(Scene.CurrentBack,400,{x:Scene.CurrentBack.x + MoveLR},Phaser.Math.Easing.Quadratic.InOut);
            Scene.addTween(Scene.NewBack,400,{x:0},Phaser.Math.Easing.Quadratic.InOut);
            let Sway = [];
            let CurtnScale = [.7,.8,.9,.92,.95,.98];
            CurtnScale = [1,1,1,1,1,1],
            Sway = (MoveLR > 0) ? [6,-4,2,-1,.25,-.05] : [-6,4,-2,1,-.25,.05];
            //console.log(Sway);
            //Scene.addTween(OldCurtains,400,{angle:Sway[0],yoyo:true},Phaser.Math.Easing.Quadratic.Out);

            //Scene.addTween(NewCurtains,400,{scaleX:.7},Phaser.Math.Easing.Quadratic.InOut);
            // const asyncForEach = async (array, callback) => {
            //     for (let index = 0; index < array.length; index++) {
            //       await callback(array[index], index, array)
            //     }
            // }
            // Scene.addTween(NewCurtains,400,{angle:Sway[0]},Phaser.Math.Easing.Quadratic.InOut,()=>
            // {
            //     Scene.addTween(NewCurtains,266,{angle:Sway[1],scaleX:CurtnScale[1]},Phaser.Math.Easing.Quadratic.InOut,()=>
            //     {
            //         Scene.addTween(NewCurtains,132,{angle:Sway[2],scaleX:CurtnScale[2]},Phaser.Math.Easing.Quadratic.InOut,()=>
            //         {
            //             Scene.addTween(NewCurtains,86,{angle:Sway[3],scaleX:CurtnScale[3]},Phaser.Math.Easing.Quadratic.InOut,()=>
            //             {
            //                 Scene.addTween(NewCurtains,43,{angle:Sway[4],scaleX:CurtnScale[4]},Phaser.Math.Easing.Quadratic.InOut,()=>
            //                 {
            //                     Scene.addTween(NewCurtains,44,{angle:Sway[5],scaleX:CurtnScale[5]},Phaser.Math.Easing.Quadratic.InOut,()=>
            //                     {
            //                         Scene.addTween(NewCurtains,44,{angle:0},Phaser.Math.Easing.Quadratic.InOut);
            //                     });
            //                 });
            //             });
            //         });
            //     });
            //     //Scene.addTween(NewCurtainTies,100,{scale:1},Phaser.Math.Easing.Bounce.Out);
            // });

            Tween.on('complete',()=>{
                //Scene.CurrentBack.removeAll();
                //Scene.CurrentBack.setPosition(0,0);
                //if(Scene.CurrentBack === Scene.BackCont1) //console.log(true);
                Scene.CurrentBack = (Scene.CurrentBack === Scene.BackCont1) ? Scene.BackCont2 : Scene.BackCont1;
                Scene.NewBack = (Scene.NewBack === Scene.BackCont1) ? Scene.BackCont2 : Scene.BackCont1;
                //if(Scene.CurrentBack === Scene.BackCont1) //console.log(true);
                let FirePlace = Scene.CurrentBack.getData('FirePlace');
                let Fire = [
                    Scene.CurrentBack.getData('Fire1'),
                    Scene.CurrentBack.getData('Fire2'),
                    Scene.CurrentBack.getData('Fire3')
                ];
                let FireWood = Scene.CurrentBack.getData('FireWood');
                let Wreath = Scene.CurrentBack.getData('Wreath');
                let Stocking = Scene.CurrentBack.getData('Stocking')
                let CurtainsArray = [
                    Scene.CurrentBack.getData('CurtainsRt'),
                    Scene.CurrentBack.getData('CurtainsLt')
                ];

                if(SelectionNumber != 0)
                {
                    Scene.addTween(FirePlace,300,{scaleY:1.3,scaleX: .7},Phaser.Math.Easing.Linear,()=>
                    {
                        Scene.addTween(FireWood,100,{alpha:1});
                        Scene.addTween(FirePlace,150,{scaleX:1.1,scaleY:.9,hold:50},Phaser.Math.Easing.Quadratic.Out,()=>
                        {
                            Scene.addTween(Wreath,175,{scale:1},Phaser.Math.Easing.Bounce.Out)
                  
                            Scene.addTween(Stocking,100,{scale:1},Phaser.Math.Easing.Quadratic.InOut);

                            _swingTween(Stocking,14,2);

                            Scene.addTween(FirePlace,100,{scaleX:1,scaleY:1},Phaser.Math.Easing.Linear,()=>
                            {
                                //Scene.addTween(Fire,150,{scaleX:1,scaleY:1});
                                resolve('resolved');
                            });

                            Scene.addTween(Fire,50,{scaleX:1.2,scaleY:1.2,hold:0},Phaser.Math.Easing.Linear,()=>
                            {
                                Scene.addTween(Fire,50,{scaleX:1,scaleY:1,},Phaser.Math.Easing.Linear,()=>
                                {
                                    _fireBounce(Fire[0]);
                                    _fireBounce(Fire[1]);
                                    _fireBounce(Fire[2]);
                                });
                            });
                        });
                    });
                    Scene.addTween(FirePlace,300,{y:FirePlace.y + 1000},Phaser.Math.Easing.Linear,()=>
                    {
                        Scene.AudioChan.Chan2.play('present_fireplace_land');
                    });
                    Scene.addTween(CurtainsArray,300,{y:'+=1000'},Phaser.Math.Easing.Linear,()=>
                    {
                        Scene.addTween(CurtainsArray,400,{scaleY:1}, Phaser.Math.Easing.Bounce.Out);
                    });
                }
                else
                {
                    resolve('resolved');
                }
            });
        });
    }
}